// Module
var code = "<div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"center center\" layout-fill> <md-button ng-click=\"$ctrl.openDialog($event)\" ng-disabled=\"$ctrl.isDisabled\" class=\"secondary\" layout-margin> <md-icon>search</md-icon> <span>PPSR</span> <md-tooltip>PPSR</md-tooltip> </md-button> </div> ";
// Exports
module.exports = code;